import './styles/header.scss';
import { MEDIA_BREAKPOINTS } from '../constants/MEDIA_BREAKPOINTS';
if (!MEDIA_BREAKPOINTS.LG_UP.matches) {
    const searchComponent = document.querySelector('search-form-component');
    if (searchComponent !== null) {
        document.querySelector('[data-action="toggle-search-form"]')?.addEventListener('click', () => {
            searchComponent.classList.toggle('hidden:md-dn');
        });
    }
}
const headerWrapper = document.querySelector('.header-sticky-wrapper');
const observerTarget = document.querySelector('[data-header-observer-target]');
if (headerWrapper !== null && observerTarget !== null) {
    const observer = new IntersectionObserver(([entry]) => {
        headerWrapper.classList.toggle('bxsh:3', !entry.isIntersecting);
    });
    observer.observe(observerTarget);
}
